import { useEffect } from "react";

import { Episode } from "@/types/Episode";
import { events } from "@/utils";
import Modal, { ModalContent, ModalHeader } from "@components/Modal";
import { ModalProps } from "@components/Modal/Modal";
import Typography from "@components/Typography";

import { useEpisode } from "../../../context";

const YoutubeModal: React.FunctionComponent<
  {
    episode: Episode;
  } & ModalProps
> = ({ show, ...props }) => {
  const { youtube_id, audioMentions, title } = useEpisode();
  const firstMentionTime = audioMentions?.[0]?.timing || 0;

  // Stop any current playback when opening the modal.
  useEffect(() => {
    show && document.dispatchEvent(events.stopAllPlayingAudio);
  }, [show]);

  return (
    <Modal show={show} {...props} data-testid="youtube-embed-modal">
      <ModalHeader>
        <Typography variant="caption">{title}</Typography>
      </ModalHeader>
      <ModalContent>
        <iframe
          data-testid="youtube-embed"
          width="100%"
          height="400"
          src={`https://www.youtube.com/embed/${youtube_id}?start=${firstMentionTime}&autoplay=1`}
          title="YouTube video player"
          frameBorder="0"
          style={{ borderRadius: 4 }}
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          referrerPolicy="strict-origin-when-cross-origin"
          allowFullScreen
        ></iframe>
      </ModalContent>
    </Modal>
  );
};

export default YoutubeModal;
